import { gql } from '@apollo/client';

export const canjeMutation = gql`
  mutation canje {
    canjeResponse(input: $input) @rest(type: "ResponseCanje", path: "/redeem/redeem-ticket", method: "POST", endpoint: "endpointcanje") {
      result
    }
  }
`;
